import { useSelector } from 'react-redux';

import * as InsuranceConstants from 'store/insurance/constants';
import * as InsuranceSelectors from 'store/insurance/selectors';

export const useDisabledFields = ({ page }) => {
  const {
    [InsuranceConstants.PAGES_VALUE_FIELDS.DISABLED]: disabled,
    [InsuranceConstants.PAGES_VALUE_FIELDS.PATCHING]: patching,
  } = useSelector(InsuranceSelectors.selectPage(page));

  return { disabled: disabled || patching };
};
